/**
 * Created by fworld on 2019/6/29.
 */
const device = {
  name: 'order',
  path: '/delivery/order',
  meta: {title: '订单管理'},
  component: () => import('@/pages/redirect'),
  redirect: {name: 'delivery.order.list'},
  children: [
    {
      name: 'delivery.order.analyze',
      path: 'analyze',
      meta: {title: '订单分析'},
      component: () => import('@/pages/Delivery/Order/Analyze'),
    },
    {
      name: 'delivery.order.compare',
      path: 'compare',
      meta: {title: '对比分析'},
      component: () => import('@/pages/Delivery/Order/Compare'),
    },
    {
      name: 'delivery.order.list',
      path: 'orders',
      meta: {title: '订单列表'},
      component: () => import('@/pages/Delivery/Order/List'),
    },
    {
      name:'delivery.order.material',
      path:'material',
      meta: {title: '物料分析'},
      component: () => import('@/pages/Delivery/Order/Material'),
    }
  ]
}

export default device
